import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].updateCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Payout Details',
				id: 'conversions',
				isEnabled: () => {
					return true;
				}
			},
			{
				name: 'Create bulk coupons',
				id: 'create_bulk',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createPartnerCoupons,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show bulk coupons',
				id: 'show_bulk',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getPartnerCoupons,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Deploy on App',
				id: 'deploy',
				isEnabled: (rowData: any) => {
					const { isDisabled } = rowData;
					if (!isDisabled) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].deployCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: (rowData: any) => {
					const { isDisabled } = rowData;
					if (isDisabled) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].deployCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.partnerCoupon,
					actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createCoupon,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
